export default __webpack_public_path__ + "static/media/sec-3-top.7db6ac76.svg";